import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="container">
      <div className="card contact-card">
        <h1>Contact Us</h1>
        <p className="subtitle">We're here to help!</p>
        
        <p className="intro-text">
          If you have any questions, concerns, or need assistance related to exams, 
          account creation, payments, or general inquiries, feel free to reach out to us. 
          Our support team will get back to you as soon as possible.
        </p>

        <div className="contact-sections">
          <div className="contact-section">
            <div className="contact-icon">📍</div>
            <h2>Our Location</h2>
            <p>Visit us at:</p>
            <address className="contact-link" style={{ fontStyle: 'normal' }}>
              Manchirevula, Narsingi,<br />
              Hyderabad, Telangana 500075
            </address>
          </div>

          <div className="contact-section">
            <div className="contact-icon">📧</div>
            <h2>Email Support</h2>
            <p>For any queries or support requests, please email us at:</p>
            <a href="mailto:contactbrainyhoot@gmail.com" className="contact-link">
              contactbrainyhoot@gmail.com
            </a>
            <p className="note">We typically respond within 2–3 business days.</p>
          </div>

          <div className="contact-section">
            <div className="contact-icon">📞</div>
            <h2>Phone Support</h2>
            <p>Call us during working hours (10 AM to 6 PM IST, Monday to Friday):</p>
            <a href="tel:+919014716089" className="contact-link">
              +91-9014716089
            </a>
          </div>

          <div className="contact-section">
            <div className="contact-icon">🕐</div>
            <h2>Support Hours</h2>
            <div className="hours-grid">
              <div className="hours-row">
                <span className="days">Monday to Friday:</span>
                <span className="time">10:00 AM – 6:00 PM IST</span>
              </div>
              <div className="hours-row closed">
                <span className="days">Saturday, Sunday & Public Holidays:</span>
                <span className="time">Closed</span>
              </div>
            </div>
          </div>

          <div className="contact-section">
            <div className="contact-icon">💡</div>
            <h2>Feedback & Suggestions</h2>
            <p>
              We value your feedback! If you have suggestions to improve our platform 
              or the student experience, please let us know via email.
            </p>
          </div>
        </div>

        <div className="thank-you">
          <p>Thank you for choosing www.brainyhoot.com to support your learning journey!</p>
        </div>
      </div>
    </div>
  );
};

export default Contact; 